import { Types } from "./TrainingContext";

const ModalReducer = (state: any, action: any) => {
  const { payload, type } = action;
  switch (type) {
    case Types.OPEN_KARDEX:
      return {
        ...state,
        _id: payload._id,
        openModalKardex: true,
      };
    case Types.CLOSE_KARDEX:
      return {
        ...state,
        _id: "",
        openModalKardex: payload.openModalKardex,
      };
    case Types.OPEN_CONFIRM_FINISH_COURSE:
      return {
        ...state,
        _id: payload._id,
        _idCTP: payload._idCTP,
        _bussinesName: payload._bussinesName,
        openConfirmFinishCourse: true,
      };
    case Types.CLOSE_CONFIRM_FINISH_COURSE:
      return {
        ...state,
        _id: "",
        _idCTP: "",
        _bussinesName: "",
        openConfirmFinishCourse: payload.openConfirmFinishCourse,
      };
    default:
      return state;
  }
};
export default ModalReducer;
